// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2DtnS","loaderOuter":"PageOverlayLoader_loaderOuter__2CvzE"};